// extracted by mini-css-extract-plugin
module.exports = {"snack":"index_snack_2ZQiA"};